import ArticleCard from "./ArticleCard";
import React from "react";
import { ArticleListContainer } from "./styles";
import PropType from "prop-types";
import { graphql, usePaginationFragment } from "react-relay";
import Button from "../../../Button";
import "./ArticlesList.css";

const ArticleListPagination = graphql`
  fragment ArticlesList_query on Query
  @argumentDefinitions(
    categories: { type: "[ID]" }
    searchText: { type: String }
    count: { type: Int, defaultValue: 12 }
    cursor: { type: String, defaultValue: null }
  )
  @refetchable(queryName: "ArticlesListPaginationQuery") {
    articles(
      categories: $categories
      searchText: $searchText
      first: $count
      after: $cursor
    ) @connection(key: "ArticlesList_articles") {
      edges {
        node {
          id
          title
          slug
          endpoint
          imageUrl
          author {
            fullName
          }
          createdOn
        }
      }
    }
  }
`;

export default function ArticlesList(props) {
  const { data, error, loadNext } = usePaginationFragment(
    ArticleListPagination,
    props.query
  );

  return (
    <>
      <ArticleListContainer>
        {data.articles
          ? data.articles.edges.map((article) => {
              return (
                <ArticleCard
                  article={article}
                  articleLink={article.node.endpoint}
                  key={article.node.id}
                />
              );
            })
          : null}
      </ArticleListContainer>
      <div className="articles-list-load-more">
        {data.articles && data.articles.pageInfo.hasNextPage ? (
          <Button
            onClick={(e) => {
              e.preventDefault();
              loadNext();
            }}
          >
            Load More
          </Button>
        ) : (
          <p>No more articles to display.</p>
        )}
      </div>

      <br />
    </>
  );
}
